import React, { useState } from 'react'
import { Formik } from 'formik'
import './PaymentForm.scss'
import Button from '../../../../../../components/button/Button'
import emailjs from 'emailjs-com'

import { cardValidation, paypalValidation } from './validation'

import PayPalIcon from '../../../../../../assets/PaymentIcons/48px_paypal 1.svg'
import AmexIcon from '../../../../../../assets/PaymentIcons/48px_amex 1.svg'
import DiscoverIcon from '../../../../../../assets/PaymentIcons/48px_discover 1.svg'
import MastercardIcon from '../../../../../../assets/PaymentIcons/48px_mastercard 1.svg'
import VisaIcon from '../../../../../../assets/PaymentIcons/48px_visa 1.svg'

import UncheckedCircle from '../../../../../../assets/PaymentIcons/CheckCircle.svg'
import CheckedCircle from '../../../../../../assets/PaymentIcons/CheckCircle--checked.svg'

import { CardElement, useStripe, useElements } from '@stripe/react-stripe-js'
import axios from 'axios'
import { useCountryContextContext } from '../../../../../../hooks/CountryContext'

import PricesData from '../../PaymentDetails/Prices'

const PaymentForm = ({ state }) => {
  const stripe = useStripe()
  const elements = useElements()
  const [paymentType, setPaymentType] = useState('paypal')
  const [resMsg, setResMsg] = useState({ msg: '', eleClass: '' })
  const [stripeErrorMessage, setStripeErrorMessage] = useState()
  const [success, setSuccess] = useState(false)
  // const selectedCountry = useCountryContextContext()
  const [buttonState, setButtonState] = useState(false)

  const STRIPE_OPTIONS = {
    style: {
      base: {
        fontSize: '16px',
        color: '#424770',
        '::placeholder': {
          color: '#aab7c4',
        },
      },
      invalid: {
        color: '#9e2146',
      },
    },
  }

  const processPayment = async (id, serviceType, values) => {

    const axiosConfig = {
      headers: {
        'Content-Type': 'application/json; charset=UTF-8',
        'Access-Control-Allow-Origin': '*',
      },
    }

    console.log("SERVICE TYPE");
    console.log(serviceType);

    const orderInfo = {
      name: `${values.firstName} ${values.lastName}`,
      orderNumber: values.orderNumber,
      email: values.email,
      phone: values.contactNumber,
      company: values.companyName,
      plan: values.plan,
      total: values.total
  }


    const response = await axios.post(
      'https://api.myvirtualoffices.com/api/Stripes/processPayment',
      // 'http://localhost:3001/api/Stripes/processPayment',
      JSON.stringify({
        id: id,
        type: serviceType.type,
        orderInfo
      }),
      axiosConfig,
    )

    if (response.data.success) {
      console.log('Successful payment')


      setSuccess(true)
      successFlow(values, serviceType)
      //REDIRECT USER TO SUCCESS PAGE
    } else {
      console.log('Payemt failed')
      setSuccess(false)
      setButtonState(false)
      failureFlow()
      setStripeErrorMessage("We're sorry there were some issues with your payment. Please try again.")
    }
  }

  const submitPayment = async (values) => {
    // let result //Set success/fail from response obj
    // setButtonState(true)
    let serviceType = PricesData[state.type].filter((item) => item.type === state.subtype)
    serviceType = serviceType[0]
    if (paymentType === 'paypal') {
      //paypal payment flow goes here
    } else {
      //stripe payment flow goes here
      const cardElement = elements.getElement(CardElement)
      // console.log("TCL: submitPayment -> cardElement", cardElement)

      // Use your card Element with other Stripe.js APIs
      const { error, paymentMethod } = await stripe.createPaymentMethod({
        type: 'card',
        card: cardElement,
      })

      if (error) {
        setStripeErrorMessage(error.message)
      } else {
        console.log('[PaymentMethod]', paymentMethod)
        try {
          const { id } = paymentMethod

          
          console.log(values);
          values.orderNumber = id;
          values.plan = serviceType.title;
          values.total = serviceType.price;
         
          processPayment(id, serviceType, values)
          


        } catch (error) {
          setButtonState(false)
          console.log(error)
        }
      }
    }
  }

  const successFlow = (values, serviceType) => {
    // let templateParams = {
    //   fullname: values.firstName + ' ' + values.lastName,
    //   company: values.companyName,
    //   email: values.email,
    //   contactNumber: values.contactNumber,
    //   serviceType: serviceType.title,
    //   country: selectedCountry.country.value,
    // }
    setResMsg({ msg: 'Your request has been received.', eleClass: 'trans-success' })

    // emailjs.send('service_ji3lq3e', 'template_p4cv6zn', templateParams, 'user_R7HCclwvKPy5qibmkBZh7').then(
    //   function (response) {
    //   },
    //   function (error) {
    //     setResMsg({ msg: 'Your request has been received.', eleClass: 'trans-success' })
    //   },
    // )

    setResMsg({ msg: 'Your order has been received.', eleClass: 'trans-success' })
  }
  const failureFlow = () => {
    //display failure message to user.

    setResMsg({ msg: 'Your order has failed, please try again.', eleClass: 'trans-failure' })
  }
  return (
    <div className="paymentForm">
      <Formik
        initialValues={{
          companyName: '',
          firstName: '',
          lastName: '',
          email: '',
          contactNumber: '',
          cardNumber: '',
          cardCVV: '',
          expiryMonth: '',
          expiryYear: '',
        }}
        validationSchema={paymentType === 'paypal' ? paypalValidation : cardValidation}
        onSubmit={(values, { setSubmitting, resetForm }) => {
          submitPayment(values)
          setSubmitting(false)
          // resetForm()
        }}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
          isSubmitting,
          submitForm,
          /* and other goodies */
        }) => (
          <form onSubmit={handleSubmit}>
            <h1>Place your order</h1>
            <h4>You are almost there. We just need a few more details to complete your order.</h4>
            <div className="paymentForm__subtitle">Basic Info</div>
            <hr />

            <div className="paymentForm__formList">
              <div className="inputField">
                <input
                  type="text"
                  name="companyName"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.companyName}
                  placeholder="Company Name (optional)"
                />
                <div className="error">{errors.companyName && touched.companyName && errors.companyName}</div>
              </div>
              <div className="inputField">
                <input
                  type="text"
                  name="firstName"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.firstName}
                  placeholder="First Name"
                />
                <div className="error">{errors.firstName && touched.firstName && errors.firstName}</div>
              </div>
              <div className="inputField">
                <input
                  type="text"
                  name="lastName"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.lastName}
                  placeholder="Last Name"
                />
                <div className="error">{errors.lastName && touched.lastName && errors.lastName}</div>
              </div>
              <div className="inputField">
                <input
                  type="email"
                  name="email"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.email}
                  placeholder="Email"
                />
                <div className="error">{errors.email && touched.email && errors.email}</div>
              </div>
              <div className="inputField">
                <input
                  type="text"
                  name="contactNumber"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.contactNumber}
                  placeholder="Contact Number"
                />
                <div className="error">
                  {errors.contactNumber && touched.contactNumber && errors.contactNumber}
                </div>
              </div>
            </div>

            <div className="paymentForm__paymentMethod">
              <div className="paymentForm__subtitle">Payment Method</div>
              <hr />
              {/* <div onClick={() => setPaymentType('paypal')} className="paypalBox">
                <img src={paymentType === 'paypal' ? CheckedCircle : UncheckedCircle} alt="" />
                <div className="paymentTypes">
                  <img src={PayPalIcon} alt="" />
                </div>
              </div> */}
              <div onClick={() => setPaymentType('card')} className="visaMastercardBox">
                <img src={paymentType === 'card' ? CheckedCircle : UncheckedCircle} alt="" />
                <div className="paymentTypes">
                  <img src={VisaIcon} alt="" />
                  <img src={MastercardIcon} alt="" />
                  <img src={AmexIcon} alt="" />
                  <img src={DiscoverIcon} alt="" />
                </div>
              </div>
            </div>

            <div className={paymentType === 'card' ? 'showable' : 'hideable'}>
              <div className="paymentForm__subtitle">Card Info</div>
              <hr />
              <CardElement options={STRIPE_OPTIONS} />
              <div className="error">{stripeErrorMessage}</div>
              <br></br>
            </div>
            <Button
              type="primary"
              text="Submit Payment"
              buttonType="submit"
              onclick={submitForm}
              isDisabled={buttonState}
            />
            <div className={`formSubmittedMessage ${resMsg.eleClass}`}>{resMsg.msg}</div>
            <p>By clicking "Submit Payment" you agree to our&nbsp;
              <a href="/terms-and-conditions" target="_blank">Terms of Service</a> and&nbsp;
              <a href="/privacy-policy" target="_blank">Privacy Policy</a>.
            </p>
          </form>
        )}
      </Formik>
    </div>
  )
}

export default PaymentForm
